import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import NewsletterWidget from "../components/newsletter-widget"

const BlogPage = () => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        posts(last: 6) {
          edges {
            node {
              slug
              featuredImage {
                node {
                  sourceUrl
                }
              }
              title
              uri
            }
          }
        }
      }
    }
  `)

  const posts = wpdata.wp.posts.edges

  return (
    <Layout className="blog-page" onlyFooter old>
      <SEO title="Blog" />
      <div className="flex container">
        <div className="left-main text-blue">
          <div className="container">
            <div className="filters">
              {[
                "Customer Stories",
                "News",
                "Media",
                "Education",
                "Product Updates",
              ].map((v, i) => {
                const path = `/blog/${v.toLowerCase().replace(" ", "-")}`
                let urlPath = ""

                if (typeof window !== "undefined") {
                  urlPath = window.location.pathname
                }

                return (
                  <Link
                    key={i}
                    to={path}
                    className={urlPath === path ? "active" : ""}
                  >
                    {v}
                  </Link>
                )
              })}
              <Link to="/blog" className="active">
                Latest posts
              </Link>
            </div>

            <h1 className="text-left page-title">Aider Blog</h1>
            <h2 className="text-left page-subtitle">
              Smart tips for growing buisinesses
            </h2>
            <p className="page-description">
              At Aider, we believe that AI can enhance small business and
              ultimately change the world. Making AI simpler to understand and
              approachable for small business owners is critical. We want to
              give you the tools to help run your business smarter as well as
              share our awesome customer success stories.
            </p>
            <h2 className="text-left page-subtitle">Latest articles:</h2>

            <div className="articles">
              {posts.map((v, i) => (
                <Link key={i} to={v.node.uri}>
                  <div className="single-article">
                    <div
                      style={{
                        backgroundImage: `url(${v.node.featuredImage.node.sourceUrl})`,
                      }}
                      className="thumbnail"
                    ></div>
                    <div className="text">
                      <h3>{v.node.title}</h3>
                      <p className="date">December 18, 2019</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="sidebar">
          <NewsletterWidget />
        </div>
      </div>
    </Layout>
  )
}

export default BlogPage
